import { useRouter } from 'vue-router/composables';
import yxhJsBridge from '@/shared/yxhJsBridge';
import { detectEnv } from '@/shared/detect';

export function useGoBack() {
  const router = useRouter();

  const goBack = () => {
    if (detectEnv.yxh) {
      yxhJsBridge.back();
    } else {
      router.back();
    }
  };

  return goBack;
}
